<template>
    <section>
        <!-- FORGOT PASSWORD FORM -->
        <div v-if="param.toggle" class="forgotPassFormWrapper">
            <div
                class="forgotPassForm d-flex justify-space-around align-center"
            >
                <v-slide-x-transition hide-on-leave>
                    <v-card
                        v-show="selectedRole === undefined"
                        class="elevation-5 forgotPassCard"
                        shaped
                    >
                        <v-btn
                            class="ma-2"
                            text
                            icon
                            color="black lighten-2"
                            @click="backBtn()"
                        >
                            <v-icon> {{ mdiArrowLeft }}</v-icon>
                        </v-btn>
                        <v-container>
                            <div class="forgotPass">
                                <img src="../../assets/forgotPass.svg" alt="">
                            </div>
                            <v-card-title>Forgot password?</v-card-title>
                            <v-card-text>
                                <div class="txtfieldWrapper">
                                    <p style="width:100%; margin:auto; text-align: center;">
                                        <span>I AM A</span>
                                    </p>
                                    <v-btn-toggle
                                        v-model="selectedRole"
                                        style="display: block; width: 100%;"
                                    >
                                        <v-btn
                                            style="width: 50%;"
                                            :color="selectedRole === 0 ? '#00C853' : ''"
                                        >
                                            <v-icon>{{ mdiAccount }}</v-icon>MEMBER
                                        </v-btn>
                                        <v-btn
                                            style="width: 50%;"
                                            :color="selectedRole === 1 ? '#00C853' : ''"
                                        >
                                            <v-icon>{{ mdiHospitalBuilding }}</v-icon>PROVIDER
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-card-text>
                        </v-container>
                    </v-card>
                </v-slide-x-transition>
                <v-slide-x-reverse-transition hide-on-leave>
                    <v-card
                        v-show="selectedRole !== undefined"
                        class="elevation-5 forgotPassCard"
                        shaped
                    >
                        <v-btn
                            class="ma-2"
                            text
                            icon
                            color="black lighten-2"
                            @click="selectedRole = undefined"
                        >
                            <v-icon>{{ mdiArrowLeft }}</v-icon>
                        </v-btn>
                        <v-container>
                            <div class="forgotPass">
                                <img src="../../assets/forgotPass.svg" alt="">
                            </div>
                            <v-card-title v-if="$route.query && $route.query.expired===null">
                                Update Password
                            </v-card-title>
                            <v-card-title v-else>
                                Forgot password?
                            </v-card-title>
                            <v-card-text>
                                <v-alert
                                    v-if="$route.query && $route.query.expired===null"
                                    border="left"
                                    prominent
                                    color="#146641"
                                    :icon="mdiInformation"
                                    dense
                                    outlined
                                    type="info"
                                >
                                    To update your password, please provide your username and email.
                                </v-alert>
                                <h4 v-show="getForgottenAccountStat" class="red--text">
                                    Account is {{ getForgottenAccountStat }}
                                    If you have concerns with your account please call HMI (02)
                                    8811-1313. Thank you!
                                </h4>
                                <div class="txtFieldWrapper">
                                    <div v-if="errUserExists">
                                        <v-alert
                                            v-model="errGetUserExists.status"
                                            dismissible
                                            class="text-center"
                                            transition="scale-transition"
                                            style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                                            type="error"
                                        >
                                            {{ errGetUserExists.msg }}
                                        </v-alert>
                                    </div>
                                    <v-form
                                        ref="form"
                                        v-model="valid"
                                        @submit.prevent="validateFunc(getForgottenAccountStat)"
                                    >
                                        <div v-show="selectedRole === 0">
                                            <v-text-field
                                                v-model="membcode"
                                                v-mask="membcodemask"
                                                clearable
                                                :rules="rules.member"
                                                label="Enter your member code"
                                                color="green accent-4"
                                                autocomplete="nope"
                                            />
                                        </div>
                                        <div v-show="selectedRole === 1">
                                            <v-text-field
                                                v-model="provider.username"
                                                clearable
                                                :rules="rules.username"
                                                label="Enter your username"
                                                color="green accent-4"
                                                autocomplete="nope"
                                            />
                                            <v-text-field
                                                v-model="provider.email"
                                                clearable
                                                :rules="rules.email"
                                                label="Enter your email"
                                                color="green accent-4"
                                                autocomplete="nope"
                                            />
                                        </div>
                                        <v-btn
                                            type="submit"
                                            :disabled="!valid"
                                            small
                                            color="green accent-4 white--text"
                                            class="my-3"
                                        >
                                            Submit
                                        </v-btn>
                                    </v-form>
                                </div>
                            </v-card-text>
                        </v-container>
                    </v-card>
                </v-slide-x-reverse-transition>
            </div>
        </div><!-- END FORGOT PASSWORD FORM -->
        <div v-else-if="showProviderForgotPass">
            <RecoverPass
                :data="provider"
                @clearProviderData="resetProvider"
            />
        </div>
        <div v-else class="displayForgotAccnt">
            <!-- DISPLAY FORGOTTEN ACCOUNT -->
            <DisplayForgottentAccnt
                v-if="getForgotPassUserInfo"
                :user-membn="getForgotPassUserInfo[0].MEMB_N"
                :user-name="getForgotPassUserInfo[0].NAME"
                :user-status="getForgotPassUserInfo[0].STATUS"
            />
        </div>
    </section>
</template>

<script>
import RecoverPass from './ForgotPassComp/RecoverPass.vue'
import { mask } from 'vue-the-mask'
import DisplayForgottentAccnt from './ForgotPassComp/DisplayForgottentAccnt.vue'
// import dlg_accountInactive from "./DialogBoxes/dlg_accountInactive"
import { mapActions, mapGetters } from 'vuex'
import { mdiAccount, mdiArrowLeft, mdiHospitalBuilding, mdiInformation } from '@mdi/js'
export default {
    components: {
        DisplayForgottentAccnt,
        // dlg_accountInactive,
        RecoverPass
    },
    directives: {
        mask
    },
    data: () => ({
        mdiAccount, mdiArrowLeft, mdiHospitalBuilding, mdiInformation,
        showProviderForgotPass: false,
        errGetUserExists: {
            status: false,
            msg: ''
        },
        selectedRole: undefined,
        membcode: '',
        provider: {
            username: null,
            email: null
        },
        rules: {
            member: [(v)=>!!v||'Member Code is required'],
            username: [()=>true],
            email: [()=>true]
        },
        membcodemask: '######',
        valid: true,
        param: {
            toggle: true
        }
    }),
    computed: {
        ...mapGetters(['getForgotPassUserInfo', 'getForgottenAccountStat', 'getUserExists', 'providerForgotPassword']),
        errUserExists() {
            if (this.getUserExists) {
                this.setErrUserExists(this.getUserExists)
            } else if (this.providerForgotPassword) {
                if (this.providerForgotPassword.status===200) {
                    this.setToggle()
                    // this.$router.push(`/recoverPass?username=${this.provider.username}&email=${this.provider.email}`)
                } else {
                    this.setErrUserExists(this.providerForgotPassword.state)
                }
            }
            return true
        }
    },
    watch: {
        selectedRole(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.valid = true
                this.$refs.form.reset()
                if (newVal === 1) {
                    this.rules.member     = [()=>true]
                    this.rules.username   = [(v)=>!!v||'Username is required', v=>(v&&v.length<=100)||'For Username, please keep it under 100 characters']
                    this.rules.email      = [v => !!v || 'Email is required', v => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid']
                } else {
                    this.rules.member     = [(v)=>!!v||'Member Code is required']
                    this.rules.username   = [()=>true]
                    this.rules.email      = [()=>true]
                }
            }
        }
    },
    mounted() {
        if (this.$route.query && this.$route.query.member === null) {
            this.selectedRole = 0
        } else if (this.$route.query && this.$route.query.provider === null) {
            this.selectedRole = 1
        } else if (this.$route.query && this.$route.query.company === null) {
            this.selectedRole = 2
        }
    },
    methods: {
        ...mapActions(['forgotPassUserInfo', 'getCsrfToken', 'forgotPassword']),
        setToggle() {
            this.param.toggle           = false
            this.showProviderForgotPass = true
        },
        backBtn() {
            if (Object.keys(this.$route.query).length > 0) {
                this.$router.push('/')
            } else {
                if (this.selectedRole === undefined) {
                    this.$router.push('/')
                } else {
                    this.selectedRole = undefined
                }
            }
        },
        resetProvider() {
            // this.provider.username      = null
            // this.provider.email         = null
            // this.showProviderForgotPass = false
        },
        setErrUserExists(msg) {
            this.errGetUserExists.status  = true
            this.errGetUserExists.msg     = msg
            setTimeout(()=>{ this.errGetUserExists.status  = false }, 3000)
        },
        async validateFunc() {
            this.param.MEMBN = this.membcode
            if (this.$refs.form.validate()) {
                if (this.selectedRole === 0) {
                    this.forgotPassUserInfo(this.param)
                } else {
                    await this.forgotPassword({ EMAIL:this.provider.email,USERNAME:this.provider.username })
                }
            }
        }
    }
}
</script>

<style scoped>
section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  background-image: url("../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
}
.forgotPassFormWrapper {
  width: 100%;
}
.displayForgotAccnt {
  display: flex;
  width: 100%;
}
.forgotPassCard {
  background-image: url("../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: right;
  width: 30%;
}
.forgotPass {
  width: 50%;
  margin: auto;
}
.forgotPass img {
  width: 100%;
}
@media (max-width: 599px) {
  .forgotPassCard {
    width: 90%;
  }
  .txtfieldWrapper {
    width: 100%;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .forgotPassCard {
    width: 40%;
  }
  .txtfieldWrapper {
    width: 100%;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .txtfieldWrapper {
    width: 100%;
  }
}
</style>
